import React, { useState, useEffect } from "react";
import "../../Styles/UniversityPage.css";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaSyncAlt,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";

import ApiService from "../../nhrc_apis/ApiService";
import { SlLocationPin } from 'react-icons/sl';
// import { SlLocationPin } from 'react-icons/sl';
import StudentChangePassword from './../Student/pages/StudentChangePassword';

const { MembershipAPI, UploadAPI, AuthAPI } = ApiService;

function UniversityPage({
  memberId,
  membershipId,
  personalData,
  onBackToPersonal,
  onComplete,
}) {

  const [formData, setFormData] = useState({
    universityName: "",
    collegeName: "",
    collegeCode: "",
    qualification: "",
    department: "",
    startYear: "",
    endYear: "",
    idFront: null,
    idBack: null,
    location: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  

  /* ================= AUTO EMAIL ================= */
  useEffect(() => {
    if (personalData?.email) {
      setFormData((prev) => ({
        ...prev,
        email: personalData.email,
      }));
    }
  }, [personalData]);

  /* ================= CAPTCHA FIXED STATE ================= */
  const [captchaData, setCaptchaData] = useState({
    id: null,
    question: "",
  });

  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValid, setCaptchaValid] = useState(null);
  const [verifying, setVerifying] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
const [errors,setErrors]=useState({});
  /* ================= LOAD CAPTCHA (FIXED) ================= */
  const loadCaptcha = async () => {
    try {
      const res = await AuthAPI.getCaptcha();

      // 🔥 IMPORTANT FIX: map backend correctly
      setCaptchaData({
        id: res.data?.captcha_id || res.data?.id,
        question: res.data?.question,
      });

      setCaptchaInput("");
      setCaptchaValid(null);

    } catch (err) {
      console.error("CAPTCHA LOAD ERROR:", err);
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  /* ================= VERIFY CAPTCHA (FIXED) ================= */
  const verifyCaptcha = async () => {
    try {
      setVerifying(true);

      if (!captchaData?.id) {
        alert("Captcha not loaded. Please refresh.");
        return;
      }

      const res = await AuthAPI.verifyCaptcha({
        captcha_id: captchaData.id,   // ✅ FIXED
        answer: captchaInput,         // backend expects this
      });

      setCaptchaValid(true);

      console.log("Captcha Verified:", res.data);

    } catch (err) {
      console.error("CAPTCHA VERIFY ERROR:", err);
      setCaptchaValid(false);
      alert(err?.response?.data?.detail || "Captcha incorrect");
    } finally {
      setVerifying(false);
    }
  };

  /* ================= INPUT ================= */
  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    setErrors((prev)=>({
      ...prev,
      [name]:"",
    }));
  };

  /* ================= FILE UPLOAD ================= */
  const uploadFile = async (file) => {
    if (!file) return "";

    const fd = new FormData();
    fd.append("file", file);
    fd.append("membership_id", membershipId);
    fd.append("file_type", "student");

    const res = await UploadAPI.uploadFile(fd);

    return (
      res.data?.fileUrl ||
      res.data?.url ||
      res.data?.file_path ||
      ""
    );
  };

  /* ================= VALIDATION ================= */
  const validateForm = () => {
    let newErrors={};
    const nameRegex=/^[A-Za-z ]{3,100}$/;
    const codeRegex=/^[A-Za-z0-9-]{2,20}$/;
    const locationRegex=/^[A-Za-z0-9 ,.-]{3,100}$/;
    const passworrdRegex=/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&*!]).{8,20}$/;




    if (!membershipId) return alert("❌ Membership ID missing");

//  university name

if(!formData.universityName.trim()){
  newErrors.universityName="University Name Is Required";

}else if(!nameRegex.test(formData.universityName)){
  newErrors.universityName="only alphabets allowed (3-100 charecters)";

}

// College Name

if(!formData.collegeName.trim()){
  newErrors.collegeName="College name is required";

}else if(!nameRegex.test(formData.collegeName)){
  newErrors.collegeName="Only alphabets allowed (3-100 charecters)";
}


// college code 

if(!formData.collegeCode.trim()){
newErrors.collegeCode="College code is required";
}else if(!codeRegex.test(formData.collegeCode)){
  newErrors.collegeCode="Invalid college code";
}
//  Qualification

if(!formData.qualification.trim()){
  newErrors.qualification="qualification is required";
}

// department
if(!formData.department.trim()){
  newErrors.department="department is rewuired";
}

// Start Year

if(!formData.startYear){
  newErrors.startYear="Start year is required";
}else if(formData.startYear.length!==4 || Number(formData.startYear)<2000){
  newErrors.startYear="Enter valid Year";
}

// Ending year
if (!formData.endYear){
  newErrors.endYear="End Year is required";
}else if(formData.endYear.length!==4 || Number(formData.endYear)<Number(formData.startYear)){
  newErrors.endYear="End year must be greater than start years"
}
// Location

if(!formData.location.trim()){
newErrors.location="Location is required";
}else if(!locationRegex.test(formData.location)){
  newErrors.location="Inavlid Location";
}

// files

if(!formData.idFront){
  newErrors.idFront="Please upload front end id proof "
}
if(!formData.idBack){
  newErrors.idBack="Please upload bakc id proof";
}

// Password

if(!formData.password){
  newErrors.password="Password is required";

}else if(!passworrdRegex.test(formData.password)){
  newErrors.password="Password must contain uppercase, lowercase, number & special charecters";
}

// Confirm password

if(!formData.confirmPassword){
  newErrors.confirmPassword="confirm password is required";
}else if(formData.password !==formData.confirmPassword){
  newErrors.confirmPassword="password do not match";
}

if (!captchaValid){
  newErrors.captch="please verify captcha";

}
setErrors(newErrors);
return Object.keys(newErrors).length===0;

    
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const frontUrl = await uploadFile(formData.idFront);
      const backUrl = await uploadFile(formData.idBack);

      const payload = {
        membership_id: membershipId,

        university_name: formData.universityName,
        college_name: formData.collegeName,
        college_code: formData.collegeCode,
        qualification: formData.qualification,
        department: formData.department,

        start_year: Number(formData.startYear),
        end_year: Number(formData.endYear),

        location: formData.location,

        email: formData.email,
        password: formData.password,
        confirm_password: formData.confirmPassword,

        captcha_id: captchaData.id,     // ✅ FIXED
        captcha_answer: captchaInput,

        id_front: frontUrl,
        id_back: backUrl,
      };

      console.log("FINAL PAYLOAD:", payload);

      await MembershipAPI.studentUniversity(payload);

      setStudentId(`NHRC-S-${Math.floor(1000 + Math.random() * 9000)}`);
      setShowPopup(true);

      if (onComplete) onComplete(payload);

    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.detail || "❌ API Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="university-wrapper">

      <h3 className="university-title">STUDENT UNIVERSITY DETAILS</h3>

      <div className="university-card">

        <form className="university-form grid-form" onSubmit={handleSubmit}>

          {/* ================= ALL YOUR FIELDS KEPT EXACT SAME ================= */}

          <div>
            <label>University Name*</label>
            <input name="universityName"  value={formData.universityName}  onChange={handleChange}  className={errors.universityName ? "input-error":""}/>
            {errors.universityName  && (
              <small className="error-text">{errors.universityName }</small>
            )}
          </div>

          <div>
            <label>College Name*</label>
            <input name="collegeName" onChange={handleChange} value={formData.collegeName}  className={errors.collegeName ? "input-error":""}/>
           {errors.collegeName &&(
            <small>{errors.collegeName}</small>
           )}

          </div>

          <div>
            <label>College Code*</label>
            <input name="collegeCode" onChange={handleChange}  value={formData.collegeCode} className={errors.collegeCode ?"input-error":""}/>

            {errors.collegeCode &&(
              <small>{errors.collegeCode}</small>
            )}
          </div>

          <div>
            <label>Qualification*</label>
            <input name="qualification" onChange={handleChange} value={formData.qualification} className={errors.qualification ? "input-error":""} />
            {errors.qualification &&(
              <small>{errors.qualification}</small>
            )}
          </div>

          <div>
            <label>Department*</label>
            <input name="department" onChange={handleChange} value={formData.department} className={errors.department ? "input-error":""} />

            {errors.department &&(
              <small>{errors.department}</small>
            )}
          </div>

          <div>
            <label>Start Year*</label>
            <input name="startYear" onChange={handleChange} value={formData.startYear} className={errors.startYear ? "input-error":""}/>
            {errors.startYear &&(
              <small>{errors.startYear}</small>
            )}
          </div>

          <div>
            <label>End Year*</label>
            <input name="endYear" onChange={handleChange} value={formData.endYear} className={errors.endYear ? "input-error":""} />
            {errors.endYear &&(
              <small>{errors.endYear}</small>
            )}
          </div>

          <div>
            <label>Location*</label>
            <input name="location" onChange={handleChange} value={formData.location} className={errors.className ? "input-error":""}/>
            {errors.location && (
              <small>{errors.location}</small>
            )}
          </div>

          <div>
            <label>ID Front*</label>
            <input type="file" name="idFront" onChange={handleChange}  className={errors.idFront ? "input-error":""}/>
            {errors.idFront &&(
              <small>{errors.idFront}</small>
            )}
          </div>

          <div>
            <label>ID Back*</label>
            <input type="file" name="idBack" onChange={handleChange} className={errors.idBack ? "input-error":""} />
            {errors.idBack &&(
              <small>{errors.idBack}</small>
            )}
          </div>

          <div>
            <label>Email*</label>
            <input type="email" name="email" value={formData.email} readOnly />
          </div>

          <div>
            <label>Password*</label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              onChange={handleChange}
              value={formData.password}
              className={errors.password ?"input-error":""}
            />
            {errors.password &&(
              <small>{errors.password}</small>
            )}


            {/* Confirm Password */}

            <label>Confirm Password*</label>
            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              onChange={handleChange}
              value={formData.confirmPassword}
              className={errors.confirmPassword? "input-error":""}
            />
            {errors.confirmPassword &&(
              <small>{errors.confirmPassword}</small>
            )}

            <span onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {/* ================= CAPTCHA UI ================= */}
         

           <div className="captcha-box">

  <label style={{ color: "black" }}>
    Captcha
  </label>

  <span style={{ color: "black" }}>
    {captchaData?.question}
  </span>

  <input
    value={captchaInput}
    onChange={(e) =>
      setCaptchaInput(e.target.value)
    }
    className={errors.captcha ? "input-error" : ""}
  />

  <button type="button" onClick={loadCaptcha}>
    <FaSyncAlt />
  </button>

  <button
    type="button"
    onClick={verifyCaptcha}
    disabled={verifying}
  >
    {verifying ? "Verifying..." : "Verify"}
  </button>

  {captchaValid === true && (
    <FaCheckCircle color="green" />
  )}

  {captchaValid === false && (
    <FaTimesCircle color="red" />
  )}

  {errors.captcha && (
    <small className="error-text">
      {errors.captcha}
    </small>
  )}
</div>

          {/* ================= BUTTONS ================= */}
          <div className="form-buttons">
            <button type="button" onClick={onBackToPersonal}>
              Back
            </button>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Register"}
            </button>
          </div>

        </form>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <h2>🎉 Student Registered</h2>
            <p><b>ID:</b> {studentId}</p>
            <p><b>Email:</b> {formData.email}</p>
            <button onClick={onBackToPersonal}>Continue</button>
          </div>
        </div>
      )}

    </div>
  );
}

export default UniversityPage;